import type { PropsWithChildren } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getHomeRouteForRole, ROUTES } from "@/constants/routes";
import { useAuth } from "@/shared/hooks/useAuth";

const ProtectedRoute = ({ children }: PropsWithChildren) => {
  const { isAuthenticated, isHydrated, user } = useAuth();
  const location = useLocation();

  if (!isHydrated) {
    return <div style={{ padding: 24 }}>Loading session...</div>;
  }

  if (!isAuthenticated) {
    return (
      <Navigate to={ROUTES.login} replace state={{ from: location.pathname }} />
    );
  }

  if (user && ["admin", "provider", "staff"].includes(user.role)) {
    return <Navigate to={getHomeRouteForRole(user.role)} replace />;
  }

  return children;
};

export default ProtectedRoute;
